import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';
import { objectAsParams } from '../../../helpers';
import ACCESS from '../../../ACCESS';

class DescargarArchivos extends FormComponent {

  componentDidMount() {
    const { hasAccess } = this.context;
    const options = [];
    if (hasAccess(ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_FACTURA_CONTADO)) {
      options.push({ Label: 'Facturas Contado', Value: '1' })
    }
    if (hasAccess(ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_FACTURA_CREDITO)) {
      options.push({ Label: 'Facturas Credito', Value: '2' })
    }
    if (hasAccess(ACCESS.COBRANZA_DESCARGA_DE_ARCHIVOS.DESCARGAR_NOTA_CREDITO)) {
      options.push({ Label: 'Notas Credito', Value: '3' })
    }
    this.FormConfig(
      { defaultUrl: 'Archivos', saveUrl: 'Ventas/save', backUrl: '/Catalogo' },
      new Form([
        Form.Field('date', 'start_date', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'end_date', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('autocomplete', 'id_cliente', 'Cliente', '', [Validators.required], 12),
        Form.Field('select', 'document_type', 'Tipo Documento Fiscal', '', [Validators.required], 6, options),
        Form.Field('select', 'format_type', 'Tipo Formato', '', [Validators.required], 6, [
          { Label: 'PDF', Value: '1' },
          { Label: 'XML', Value: '2' },
          { Label: 'AMBOS', Value: '3' },
        ]),
      ], ['Descargar'], 'Descargar Archivos'), this.formData
    )
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;
    if (this.clienteSearch) {
      params.cliente = this.clienteSearch;
      this.clienteSearch = null;
    }

    const Res = await Http.get(`revision-evidencia/form?${objectAsParams(params)}`);

    if (!Res.error) {
      const { clientes } = Res.data;

      if (clientes) {
        newForm = Form.FieldOptions(newForm, 'id_cliente', clientes, 'id', 'cliente');
      }
    }

    newForm = Form.ValueChange(newForm, {
      id_cliente: (field) => {((field.ValueAt && field.ValueAt.length > 2) || (field.Value && field.Value.length > 0)) && (this.clienteChange(field)) }
    });
    return newForm;
  }

  clienteChange = async (field) => {
    if (!(field.Value && !isNaN(field.Value))) {
      this.clienteSearch = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    vals.start_date = moment(vals.start_date).format('YYYY-MM-DD');
    vals.end_date = moment(vals.end_date).format('YYYY-MM-DD');
    const Resp = await Http.get(`facturas/fiscal-files?${objectAsParams(vals)}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/octet-stream' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `archivos_${vals.start_date}-${vals.end_date}.zip`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender on />
      </div>
    )
  }
}

export default withRouter(DescargarArchivos)
